import { gql } from "@apollo/client";

import type { PaginationType } from "@/components/pagination";

interface MutualFriendDataType {
  id: string;
  imageId?: string;
  username: string;
}

type MutualFriendsType = PaginationType<MutualFriendDataType>;

interface UserType {
  bio?: string;
  experiencesCount: number;
  firstName: string;
  followersCount: number;
  id: string;
  imageId?: string;
  isBlocked?: boolean;
  isFollower?: boolean;
  isFollowing?: boolean;
  lastName: string;
  location: string;
  mutualFriends?: MutualFriendsType;
  reviewsCount?: number;
  username: string;
}

export interface DataType {
  user: UserType;
}

export interface VariablesType {
  isUser: boolean;
  userId: string;
}

export const QUERY = gql`
  query User($isUser: Boolean!, $userId: ID!) {
    user(userId: $userId) {
      id
      bio
      experiencesCount
      firstName
      followersCount
      imageId
      isBlocked @include(if: $isUser)
      isFollowing @include(if: $isUser)
      isFollower @include(if: $isUser)
      lastName
      location
      mutualFriends @include(if: $isUser) {
        count
        objects {
          id
          imageId
          username
        }
      }
      reviewsCount
      username
    }
  }
`;
